var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mfaRequired)?_c('MultiFactorAuthentication',{attrs:{"username":_vm.username,"session":_vm.session},on:{"cancel":_vm.onCancel}}):_c('PasswordAuthentication',{on:{"mfa-required":_vm.onSignIn}})
}
var staticRenderFns = []

export { render, staticRenderFns }